import { useParams, useLocation, Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
  isCurrent: boolean;
}

export default function Breadcrumb() {
  const { year, themeId } = useParams<{ year?: string; themeId?: string }>();
  const location = useLocation();

  // Don't render breadcrumb on Landing page (no parameters)
  if (!year) {
    return null;
  }

  // Build breadcrumb items array based on current route
  const items: BreadcrumbItem[] = [
    {
      label: 'Gallery Home',
      path: '/',
      isCurrent: false,
    },
  ];

  // Add year breadcrumb item
  if (year) {
    items.push({
      label: year,
      path: `/${year}`,
      isCurrent: !themeId,
    });
  }

  // Add theme breadcrumb item if on theme page
  if (themeId) {
    // Extract theme title from location state, fallback to "Theme"
    const themeTitle = (location.state as { themeTitle?: string })?.themeTitle || 'Theme';
    items.push({
      label: themeTitle,
      path: location.pathname,
      isCurrent: true,
    });
  }

  return (
    <nav aria-label="Breadcrumb" className="mx-auto w-full max-w-7xl px-4 py-3">
      <ol className="flex items-center gap-2 text-sm sm:text-base">
        {items.map((item, index) => (
          <li key={item.path} className="flex items-center gap-2">
            {index > 0 && (
              <span className="text-gray-400 px-1" aria-hidden="true">
                /
              </span>
            )}
            {item.isCurrent ? (
              <span className="text-gray-600 truncate max-w-[150px] sm:max-w-none" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link
                to={item.path}
                className="text-fwo-blue hover:text-fwo-blue/80 transition-colors py-2 px-1 min-h-[44px] min-w-[44px] flex items-center truncate max-w-[150px] sm:max-w-none"
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
